import { Api } from "./api-client";
import type { ApiLoginPost200Response, UserResponse } from "./lib";

/**
 * Adapter for authentication API calls.
 * Maps generated SecurityApi to interface expected by auth-service.
 */
export const AuthApiAdapter = {
  /**
   * Login with email and password
   */
  async login(email: string, password: string): Promise<ApiLoginPost200Response> {
    const response = await Api.security.apiLoginPost({
      apiLoginPostRequest: {
        username: email, // Backend expects 'username' field
        password: password,
      },
    });
    return response.data;
  },

  /**
   * Refresh access token using refresh token
   */
  async refresh(refreshToken: string): Promise<ApiLoginPost200Response> {
    const response = await Api.security.apiTokenRefreshPost({
      apiTokenRefreshPostRequest: {
        refresh_token: refreshToken,
      },
    });
    return response.data;
  },

  /**
   * Get current user from /api/me endpoint
   */
  async me(): Promise<UserResponse> {
    const response = await Api.security.getAppMeMe();
    return response.data.data!; // Extract 'data' wrapper
  },
};
